import { render } from "./_Index.vue?vue&type=template&id=a4f953da&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=a4f953da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4f953da"

export default script